module.exports = __webpack_public_path__ + "img/no_message.8a77e359.png";